import { mapState, mapMutations } from 'vuex'
import IcClose from '@/assets/svg/ic-close.svg?inline'

export default {
  name: 'Modal',
  props: {
    fullScreenWidth: null,
    width: {
      type: Number
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    noHideOverlay: {
      type: Boolean,
      default: false
    },
    modalError: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IcClose
  },
  static() {
    return {
      adaptiveQl: null
    }
  },
  data() {
    return {
      isOpen: false,
      fullScreen: false
    }
  },
  computed: {
    ...mapState({
      modalsCount: state => state.modalsCount
    })
  },
  mounted() {
    if (this.fullScreenWidth) {
      this.adaptiveQl = window.matchMedia(`(max-width: ${this.fullScreenWidth}px)`)
      this.adaptiveQl.addListener(this.onAdaptiveChange)
      this.onAdaptiveChange()
    }
  },
  beforeDestroy() {
    if (this.isOpen) {
      this.setModalsCount(this.modalsCount - 1)
    }
    if (this.adaptiveQl) {
      this.adaptiveQl.removeListener(this.onAdaptiveChange)
    }
  },
  methods: {
    ...mapMutations({
      setModalsCount: 'SET_MODALS_COUNT'
    }),
    show() {
      if (!this.isOpen) {
        this.isOpen = true
        this.setModalsCount(this.modalsCount + 1)
      }
    },
    hide() {
      this.$emit('hide')
      if (this.isOpen) {
        this.isOpen = false
        this.setModalsCount(this.modalsCount - 1)
      }
    },
    onAdaptiveChange() {
      this.fullScreen = this.adaptiveQl.matches
    }
  },
  watch: {
    '$route'() {
      if (this.isOpen && !this.modalError) {
        this.hide()
      }
    }
  }
}